import type {
    PropCallback,
    PropDefaults,
    PropElement,
    PropTypes,
    RecordComponent,
} from "@platform/react-storybook/Component";

import type { PropContainerWww } from "@front/components/Container/Www/types";
import type { PropSectionFooter } from "@front/components/Container/Www/_Footer/types";

import Namespace from "./_index.scss";

import { SectionAssessment } from "./_Assessment";
import { SectionBecome } from "./_Become";
import { SectionCategories } from "./_Categories";
import { SectionPreview } from "./_Preview";
import { SectionScholarship } from "./_Scholarship";
import { SponsorSection } from "./_Sponsor";

export const { NAME_CONTAINER_WWW_ROOT, TYPE_CONTAINER_WWW_ROOT } = Namespace;

export const SECTION_CONTAINER_WWW_ROOT = {
    SectionAssessment,
    SectionBecome,
    SectionCategories,
    SectionPreview,
    SectionScholarship,
    SponsorSection,
};
// Sections that are not being used by current Container
export type SectionContainerWwwRoot = Omit<
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    Parameters<PropContainerWww["children"]>[0],
    "SectionHeader" | "SectionMenu" | "SectionFooter"
> &
    RecordComponent<typeof SECTION_CONTAINER_WWW_ROOT>;

export type PropContainerWwwRoot = Omit<PropElement, "children"> & {
    children: PropElement["children"] | PropCallback<SectionContainerWwwRoot>["children"];
    onFooterClick?: PropSectionFooter["onClickStarted"];
    isBackgroundEnabled?: boolean;
};

export const DEF_CONTAINER_WWW_ROOT: PropDefaults<PropContainerWwwRoot> = {
    onFooterClick: () => undefined,
    isBackgroundEnabled: true,
};

export type PropTypesContainerWwwRoot = PropTypes<
    PropContainerWwwRoot,
    typeof DEF_CONTAINER_WWW_ROOT
>;
